import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import { bindOptionSelectorFactory } from '@ff-os/pdp-shared-redux/pluginBindings';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { matchActiveVariant } from '@ff-scene-plugins/gift-shared/matchActiveVariant';
import { selectActiveInputs } from '../slices/inputsSlice';
import { GiftPdpState } from '../store';

const variantAdapter = createEntityAdapter<GiftJson.Variant<any>>();
export const adapterSelectors = variantAdapter.getSelectors<GiftPdpState>(s => s.scene.options.variants);

export const selectAllVariants = adapterSelectors.selectAll;

export const selectActiveVariant = createSelector([
    selectAllVariants,
    selectActiveInputs
], matchActiveVariant);

export const selectActiveVariantId = createSelector(
    selectActiveVariant,
    v => v.id);

export const selectActiveVariantSku = createSelector(
    selectActiveVariant,
    v => v.externalId);

export const createOptionBindings = <TOptions>() => ({
    createOptionSelector: bindOptionSelectorFactory(adapterSelectors).to<TOptions>()
});